import store from '@/store'
import router from '@/router'
import { showConfirmDialog, showToast } from 'vant'
import { pvuvInside } from '@/utils/pvuv'
import appJS from './appJS'
import { getOutApiUrl, getMemberApiUrl } from '@/api/base'
import { isMenuPath, urlParamsObject, isApp, isIOS } from './common'
import global from '../constant/Global'
import CryptoJS from 'crypto-js'
import { h5CheckIn } from '@/api/product'
/*****
 * 产品跳转
 * params
 * product: 产品信息
 * replace: 是否替换当前页面
 * uv: 是否记录uv
 *  */
// 后端可能返回不带 http(s):// 的外部链接（如 `www.baidu.com`）
// 直接赋值给 `location.href` 会被浏览器当成相对路径，拼出如 `http://localhost:2800/www.baidu.com`
const normalizeExternalUrl = (url) => {
  if (!url || typeof url !== 'string') return url
  const trimmed = url.trim()
  if (!trimmed) return trimmed

  // 已有协议
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(trimmed)) return trimmed

  // 协议相对
  if (trimmed.startsWith('//')) {
    if (typeof location !== 'undefined' && location.protocol) return `${location.protocol}${trimmed}`
    return `https:${trimmed}`
  }

  // 以 `/` 开头通常是站内路径，保持不变
  if (trimmed.startsWith('/')) return trimmed

  // 形如 `www.baidu.com` / `baidu.com/path?x=1` 的主机地址，补 https://
  const looksLikeHost = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(:\d+)?([/?#].*)?$/.test(trimmed)
  if (looksLikeHost) return `https://${trimmed}`

  return trimmed
}

/** 与产品页列表跳转一致：带上列表里的额度/名称，避免 Join 首屏仅 productId 时额度为 0（SF208 在 WAIT 等状态可能不下发 quota） */
const buildProductJoinQuery = (product) => ({
  productId: String(product.id),
  productName: product.name || '',
  quota: product.quota ?? '',
  link: product.link || product.url || product.loanUrl || ''
})

const IOS_GUEST_BROWSE_PATHS = [
  '/',
  '/base-search',
  '/mall',
  '/goods-category',
  '/goods-list',
  '/goods-detail',
  '/third-mall',
  '/third-mall/detail',
  '/activity-page',
  '/integral'
]
const isIosGuestBrowsePath = (path) => {
  const pathname = String(path || '').split('?')[0]
  return isIOS() && IOS_GUEST_BROWSE_PATHS.includes(pathname)
}
const canIosGuestOpenAd = (item) => {
  if (!isIOS() || item?.urlType !== 'IN_URL') return false
  if (['GOODS', 'GXF_GOODS', 'ACTIVITYPAGE'].includes(item?.queryType)) return true
  return item?.queryType === 'CUSTOM' && isIosGuestBrowsePath(item.url)
}
const canIosGuestOpenFunc = (item) => {
  if (!isIOS() || item?.funcType !== 'IN') return false
  if (['SPU', 'GXF_SPU', 'CATEGORY', 'ACTIVITYPAGE'].includes(item?.linkType)) return true
  return item?.linkType === 'CUSTOM' && isIosGuestBrowsePath(item.linkTypeValue)
}

export const productRouter = async (product, replace, uv = false) => {
  const user = store.getters.userInfo
  if (!user) {
    appJS.callLogin()
    return
  }
  if (product.isCredit === 'Y') {
    if (user.flow === 'FINISH') {
      // pv+uv记录
      uv && (await pvuvInside(product.id, user.id))
      if (product.type === 'H5' && product.isInput === 'Y') {
        // h5登记
        await h5CheckIn({ productId: product.id })
      }
      if (product.type === 'H5') {
        const link = normalizeExternalUrl(product.link)
        isApp() ? appJS.appOtherWebView(link) : (location.href = link)
      } else if (product.type === 'FORM') {
        if (replace) {
          router.replace({ name: 'OrderApply', params: { productId: product.id } })
        } else {
          router.push({ name: 'OrderApply', params: { productId: product.id } })
        }
      } else if (product.type === 'JOIN') {
        if (replace) {
          router.replace({ path: '/product/join', query: buildProductJoinQuery(product) })
        } else {
          router.push({ path: '/product/join', query: buildProductJoinQuery(product) })
        }
      } else if (product.type === 'JOIN_WHOLE') {
        router.push({ path: '/prodcut/wholeProcess', query: { productId: product.id } })
      }
    } else {
      creditFun(user)
    }
  } else {
    // pv+uv记录
    uv && (await pvuvInside(product.id, user.id))
    if (product.type === 'H5' && product.isInput === 'Y') {
      // h5登记
      await h5CheckIn({ productId: product.id })
    }
    if (product.type === 'H5') {
      const link = normalizeExternalUrl(product.link)
      isApp() ? appJS.appOtherWebView(link) : (location.href = link)
    } else if (product.type === 'FORM') {
      if (user.flow === 'FINISH') {
        router.push({ path: '/order-apply', params: { productId: product.id } })
      } else {
        creditFun(user)
      }
    } else if (product.type === 'JOIN') {
      router.push({ path: '/product/join', query: buildProductJoinQuery(product) })
    } else if (product.type === 'JOIN_WHOLE') {
      router.push({ path: '/prodcut/wholeProcess', query: { productId: product.id } })
    }
  }
}
const creditFun = (user) => {
  showConfirmDialog({
    title: '提示',
    message: '该产品需要您完成授信后才可以申请。',
    confirmButtonText: '前往授信'
  })
    .then(() => {
      router.push({ path: user.flow === 'INFO' ? '/cust-info-result' : '/credit-facilities' })
    })
    .catch(() => {
      // on cancel
    })
}
// 广告跳转
export const adRouter = async (item, config) => {
  const user = store.getters.userInfo
  if (!user && !canIosGuestOpenAd(item)) {
    appJS.appLogin()
    return
  }
  if (item.urlType === 'IN_URL') {
    if (item.queryType === 'PRODUCT') {
      config?.replace
        ? router.replace({ path: '/product/detail', query: { productId: item.queryTypeValue } })
        : router.push({ path: '/product/detail', query: { productId: item.queryTypeValue } })
    } else if (item.queryType === 'GOODS' || item.queryType === 'GXF_GOODS') {
      if (item.queryTypeValue) {
        goodsRouter(
          { spuId: item.queryTypeValue, categoryGroup: item.categoryGroup, replace: config?.replace },
          item.queryType === 'GXF_GOODS' ? 'D' : ''
        )
      } else {
        config?.replace ? router.replace('/goods-list') : router.push('/goods-list')
      }
    } else if (item.queryType === 'CUSTOM') {
      const url = isMenuPath(item.url) // 菜单页
      if (url) {
        menuRouter(item.url, config?.replace)
      } else {
        const query = urlParamsObject(item.url)
        config?.replace ? router.replace({ path: item.url, query }) : router.push({ path: item.url, query })
      }
    } else if (item.queryType === 'ACTIVITYPAGE') {
      config?.replace
        ? router.replace({ path: '/activity-page', query: { id: item.queryTypeValue } })
        : router.push({ path: '/activity-page', query: { id: item.queryTypeValue } })
    }
  } else if (item.urlType === 'OUT_URL') {
    if (item.queryType === 'API') {
      // 外部 api
      if (item.queryTypeValue === 'CHNLVIP') {
        const ress = await getMemberApiUrl({ orderId: item.orderId })
        appJS.appOtherWebView(ress.data)
      } else {
        getOutApiUrl({ sceneCode: item.queryTypeValue }).then((res) => {
          const title = item.queryTypeValue === 'FZS' ? this.$env.appName : ''
          router.push('/iframe-view/webview?title=' + title + '&url=' + encodeURIComponent(res.data))
          //appJS.appOtherWebView(res.data)
        })
      }
    } else {
      appJS.appOtherWebView(item.url)
    }
  }
}
// 功能组跳转
export const funcRouter = (item) => {
  const user = store.getters.userInfo
  if (user || canIosGuestOpenFunc(item)) {
    // 是否需要登录
    if (item.funcType === 'IN') {
      if (item.linkType === 'PRODUCT') {
        router.push({ path: '/product/detail', query: { productId: item.linkTypeValue } })
      } else if (item.linkType === 'SPU' || item.linkType === 'GXF_SPU') {
        if (item.funcValues[0].relationId) {
          goodsRouter(
            { spuId: item.funcValues[0].relationId, categoryGroup: item.funcValues[0].categoryGroup },
            item.linkType === 'GXF_SPU' ? 'D' : ''
          )
        } else {
          router.push('/goods-list')
        }
      } else if (item.linkType === 'CATEGORY') {
        // 跳转分类
        const funcValues = item.funcValues[0].relationId.split(',')
        router.push({ path: '/goods-list', query: { categoryId: funcValues[funcValues.length - 1] } })
      } else if (item.linkType === 'CUSTOM') {
        const url = isMenuPath(item.linkTypeValue) // 菜单页
        if (url) {
          menuRouter(item.linkTypeValue)
        } else {
          const query = urlParamsObject(item.linkTypeValue)
          router.push({ path: item.linkTypeValue, query })
        }
      } else if (item.linkType === 'APPVIEW') {
        // app页面
        // JsBridge.callHandler(item.linkTypeValue,
        //   () => {})
      } else if (item.linkType === 'ACTIVITYPAGE') {
        router.push({ path: '/activity-page', query: { id: item.linkTypeValue } })
      } else if (item.linkType === 'VIRTUAL') {
        // 权益购买
        router.push({ path: '/member/equity-buy', query: { id: item.linkTypeValue } })
      } else if (item.linkType === 'TELE') {
        // 权益购买
        router.push({ path: '/telephone' })
      }
    } else if (item.funcType === 'OUT') {
      if (item.linkType === 'API') {
        getOutApiUrl({ sceneCode: item.linkTypeValue }).then((res) => {
          const title = item.linkTypeValue === 'FZS' ? this.$env.appName : ''
          router.push('/iframe-view/webview?title=' + title + '&url=' + encodeURIComponent(res.data))
          // appJS.appOtherWebView(res.data)
        })
      } else {
        appJS.appOtherWebView(item.linkTypeValue)
      }
    }
  } else {
    appJS.appLogin()
  }
}
// 商品详情页
export const goodsRouter = (item, type, typeId) => {
  const user = store.getters.userInfo
  const params = { goodsId: item.spuId ,fiProductId: item?.fiProductId, chnlType: item?.chnlType}
  if (type) {
    params['type'] = type
  }
  if (typeId && type === 'benefit') {
    params['packageId'] = typeId
    params['skuId'] = item.skuId
  }
  if (item.categoryGroup === 'MOVIE') {
    // 电影票
    getMoviesUrl({ spuId: item.spuId }).then((res) => {
      if (res.rspCode === '0000') {
        appJS.appOtherWebView(res.data)
        //location.href = res.data
      }
    })
  } else {
    item.replace
      ? router.replace({ path: '/goods-detail', query: params })
      : router.push({ path: '/goods-detail', query: params })
  }
  // if (item.categoryGroup === 'TELE') {
  //   router.push({path: '/goods-tele', query: {goodsId: item.spuId} })
  // } else {
  //   router.push({path: '/goods-detail', query: {goodsId: item.spuId} })
  // }
}
// 菜单页
/****
 *
 * @param {*} path 菜单路径
 * @param {*} replace 是否replace
 */
export const menuRouter = (path, replace) => {
  const url = isMenuPath(path) // 菜单页
  if (url) {
    if (path === '/member' || path === '/cash-loan') {
      // 特殊的省钱卡
      router.push(path)
      return
    }
    if (localStorage.getItem('currentRouter') !== '/') {
      // 当前路由不是main
      localStorage.setItem('componentName', path)
      router.push({ name: 'Main' })
    } else {
      // 切换菜单选显卡
      store.commit('MENU_PATH', path)
    }
  } else {
    if (replace) {
      // replace
      router.replace(path)
    } else {
      router.push(path)
    }
  }
}
const generate32BitRandomNumber = (length = 32) => {
  let result = ''
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}
// 在线客服
export const customerService = () => {
  const user = store.getters.userInfo
  if (!user) {
    appJS.appLogin()
    return
  }
  // const timestamp = new Date().getTime()
  // const nonce = generate32BitRandomNumber()
  // const web_token = user.phone
  // const c_phone = user.phone
  // const sign_str = `nonce=${nonce}&timestamp=${timestamp}&web_token=${web_token}&${global.CUSTOMER_SERVICE_SHA1_KEY}`;
  // const sign = CryptoJS.SHA1(sign_str).toString().toUpperCase();
  // const url = `https://szhuading.s2.udesk.cn/im_client?c_phone=${c_phone}&nonce=${nonce}&signature=${sign}&timestamp=${timestamp}&web_token=${web_token}`
  // appJS.appOtherWebView(url)
}
// h5产品非登录导流统计
export const h5ProductUvPvRouter = async (product, replace = false) => {
  const user = store.getters.userInfo
  // pv+uv记录
  await pvuvInside(product.id, user ? user.id : null)
  if (product.type === 'H5' && product.isInput === 'Y' && user) {
    // h5登记
    await h5CheckIn({ productId: product.id })
  }
  if (!product.link) {
    showToast('链接不存在')
    return
  }
  const link = normalizeExternalUrl(product.link)
  if (replace) {
    isApp() ? appJS.appOtherWebView(link) : location.replace(link)
  } else {
    isApp() ? appJS.appOtherWebView(link) : (location.href = link)
  }
}
